
    <template>
      <section class="content element-doc">
        <h2 id="qu-yu-jie-ping"><a class="header-anchor" href="#qu-yu-jie-ping">¶</a> 区域截屏</h2>
<pre><code class="language-js">// 导入
import { downloadImage } from 'sh-ui-v2'


/**
 *  使用方法
 * @param {string} elm 截图区域class或id且为页面唯一标识,例如：'.box'、'#box'
 * @param {strung} name 下载文件名，没传默认为随机字符
 * @param {array || string} elms  截图区域内需要隐藏的参数,非必传
 */

downloadImage({ elm: elm, name: '文件名', elms: ['.class1', '#id1'] })
downloadImage({elm:'.class', '文件名',elms: '.class'})

</code></pre>
<h3 id="shi-li"><a class="header-anchor" href="#shi-li">¶</a> 示例</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;screenshot&quot;&gt;
    &lt;el-button @click=&quot;onDownloadImages&quot; class=&quot;image-btn&quot;&gt;下载图片&lt;/el-button&gt;
    &lt;div class=&quot;img-box&quot;&gt;
      &lt;img style=&quot;width: 100%&quot; src=&quot;/image/60850cbe-bced-415b-853a-c62040c0c003.jpeg&quot; alt=&quot;&quot; /&gt;
    &lt;/div&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  const { downloadImage } = require('#/utils/index.js')
  export default {
    data() {
      return {
        msg: 'hello world'
      }
    },

    methods: {
      onDownloadImages() {
        // 完整示例
        downloadImage({ elm: '.img-box', name: '图片1', elms: ['.image-btn'] })
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="can-shu-shuo-ming"><a class="header-anchor" href="#can-shu-shuo-ming">¶</a> 参数说明</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>elm</td>
<td>截图区域 class 或 id 且为页面唯一标识,例如：'.class'、'#id'</td>
<td>string</td>
<td>-</td>
</tr>
<tr>
<td>name</td>
<td>下载文件名，没传默认为随机字符</td>
<td>string</td>
<td>-</td>
</tr>
<tr>
<td>elms</td>
<td>截图区域内需要隐藏的元素,例如：['.class1'、'#id1'] or '.class1',非必传</td>
<td>array</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"screenshot"},[_c('el-button',{staticClass:"image-btn",on:{"click":_vm.onDownloadImages}},[_vm._v("下载图片")]),_vm._v(" "),_vm._m(0)],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-box"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/image/60850cbe-bced-415b-853a-c62040c0c003.jpeg","alt":""}})])}]

  
    const { downloadImage } = require('#/utils/index.js')
  const democomponentExport = {
    data() {
      return {
        msg: 'hello world'
      }
    },

    methods: {
      onDownloadImages() {
        // 完整示例
        downloadImage({ elm: '.img-box', name: '图片1', elms: ['.image-btn'] })
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  